import AgentLanding from "@/components/AgentLanding";
import { buzzConfig } from "@/content/ai-team/buzz";

const Buzz = () => <AgentLanding config={buzzConfig} />;

export default Buzz;
